import Vue from 'vue'

const DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{1,2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?\s*(Z|[+-]\d{2}(?::?\d{2})?)?$/

const clockState = Vue.observable({
  now: Math.trunc(Date.now() / 1000),
  syncedAt: null,
  serverOffsetSec: null
})

let tickIntervalId = null
let syncIntervalId = null
let serverEpochMs = Date.now()
let clientEpochAtSyncMs = Date.now()

function offsetToSeconds (tz) {
  if (!tz || tz === 'Z') {
    return 0
  }

  const sign = tz.charAt(0) === '-' ? -1 : 1
  const digits = tz.slice(1).replace(':', '')
  const hours = parseInt(digits.slice(0, 2), 10)
  const minutes = parseInt(digits.slice(2, 4) || '0', 10)

  return sign * (hours * 3600 + minutes * 60)
}

function parseLoose (str) {
  const ms = new Date(str.replace(' ', 'T')).getTime()

  return Number.isNaN(ms) ? null : Math.trunc(ms / 1000)
}

export function parseServerWallClock (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (typeof value === 'number') {
    return Math.trunc(value > 1e11 ? value / 1000 : value)
  }

  const str = String(value).trim()
  const match = DATE_TIME_RE.exec(str)

  if (!match) {
    return parseLoose(str)
  }

  const base = Date.UTC(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], +(match[6] || 0)) / 1000

  if (match[7]) {
    return base - offsetToSeconds(match[7])
  }

  if (clockState.serverOffsetSec !== null) {
    return base - clockState.serverOffsetSec
  }

  return parseLoose(str)
}

function updateClockNow () {
  const elapsedMs = Date.now() - clientEpochAtSyncMs
  clockState.now = Math.trunc((serverEpochMs + elapsedMs) / 1000)
}

function applyServerTime (serverTime) {
  const parsedSec = parseServerWallClock(serverTime)

  if (parsedSec === null) {
    return false
  }

  const match = typeof serverTime === 'string' ? DATE_TIME_RE.exec(serverTime.trim()) : null

  if (match && match[7]) {
    clockState.serverOffsetSec = offsetToSeconds(match[7])
  }

  serverEpochMs = parsedSec * 1000
  clientEpochAtSyncMs = Date.now()
  clockState.syncedAt = serverTime
  updateClockNow()

  return true
}

async function syncServerClock () {
  try {
    const response = await fetch(`${location.protocol}//${window.HOSTNAME}/leilao/get-timestamp`, {
      method: 'GET'
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()

    if (!applyServerTime(data)) {
      throw new Error('Timestamp invalido recebido do servidor')
    }
  } catch (error) {
    console.error('Clock sync error:', error)
    updateClockNow()
  }
}

export function initClockSync (syncIntervalMs = 15000) {
  if (tickIntervalId !== null) {
    return clockState
  }

  updateClockNow()
  syncServerClock()

  tickIntervalId = window.setInterval(updateClockNow, 1000)
  syncIntervalId = window.setInterval(syncServerClock, syncIntervalMs)

  return clockState
}

export function getClockState () {
  return clockState
}

export function stopClockSync () {
  if (tickIntervalId !== null) {
    window.clearInterval(tickIntervalId)
    tickIntervalId = null
  }

  if (syncIntervalId !== null) {
    window.clearInterval(syncIntervalId)
    syncIntervalId = null
  }
}



// WEBPACK FOOTER //
// ./src/services/clock.js